var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgX = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.5,
    d: "M.834 1.096h3.395l3.138 4.202L11.273 1l.928.016-4.372 4.886 4.483 6.002H8.92L5.957 7.988 2.34 12h-.913l4.082-4.584-4.674-6.32Zm3.075.62H2.116l7.173 9.551h1.76l-7.14-9.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 0.093,
    d: "M.834 1.05H.742l.055.074 4.651 6.29-4.057 4.555-.068.077h1.036l.014-.015 3.581-3.97 2.928 3.87.014.019h3.509l-.056-.074-4.46-5.971 4.346-4.858.068-.076L12.2.97l-.928-.016h-.02l-.015.015L7.37 5.225 4.266 1.07l-.014-.019H.834Zm10.123 10.17H9.312L2.208 1.764h1.677l7.072 9.458Z"
  })));
});
SvgX.displayName = "SvgX";
export default SvgX;